export const AUTH_ERROR_CODES = {
  USER_INACTIVE: "user_inactive",
  INVALID_CREDENTIALS: "invalid_credentials",
};

export const AUTH_ERROR_STORAGE_KEY = "authErrorCode";

export const getAuthErrorMessage = (errorCode, t) => {
  switch (errorCode) {
    case AUTH_ERROR_CODES.USER_INACTIVE:
      return t("login.userInactive");
    case AUTH_ERROR_CODES.INVALID_CREDENTIALS:
      return t("login.invalidCredentials");
    default:
      return typeof errorCode === "string" ? errorCode : t("login.loginError");
  }
};
